import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import axios from "axios";
import FormIndex from "../../components/paet/FormNumeroSerie";
import Alert from "../../utils/alert";
import ConfigurationManager from "../../settings/ConfigurationManager";

export default function Index() {
	const [token, setToken] = useState("");

	useEffect(() => {
		const obtenerTokenInicial = async () => {
			const response = await axios.get(
				`${ConfigurationManager.API_URL}/Token/GenerateToken`
			);
			setToken(response.data.key);
		};

		obtenerTokenInicial();
	}, []);

	return (
		<>
			<Helmet>
				<title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
				<meta name="description" content={``} />
				<meta name="robots" content="noindex, follow" />
			</Helmet>
			<section>
				<div className="container">
					<div className="card formulario mt-5 mb-5">
						<div className="card-header">
							<div className="form-row">
								<div className="titulo">
									Formulario de Retiro de Pensión Anticipada por Enfermedad Terminal
								</div>
							</div>
							<div className="form-row">
								<div className="subtitulo mt-3">
									Comienza tu solicitud aquí.
								</div>
							</div>
						</div>
						<div className="card-body paet">
							<FormIndex />
							<Alert
								image="warning"
								className="alert-secondary"
								message={[
									"Este portal es ",
									<strong key="s">
										exclusivo para los Afiliados, Pensionados AFP Modelo.
									</strong>,
									" Si no sabes a qué AFP estás afiliado, ",
									<a
										key="a"
										href="https://www.spensiones.cl/apps/certificados/formConsultaAfiliacion.php"
										target="blank_"
										className="green-a"
									>
										haz click aquí
									</a>,
									".",
								]}
							/>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}
